import { render, staticRenderFns } from "./square-create-account.vue?vue&type=template&id=1ec67525&scoped=true&"
import script from "./square-create-account.vue?vue&type=script&lang=js&"
export * from "./square-create-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec67525",
  null
  
)

export default component.exports